/* STRING */
String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

String.prototype.limit = function (charCount) {
    var target = this;
    return target.substring(0, Math.min(this.length, charCount));
};

/* ARRAY */
Array.prototype.remove = function(item) {
    if (item) {
        const index = this.indexOf(item);
        if (index > -1) {
            this.splice(index, 1);
        }
    }

    return this;
};

Array.prototype.add = function(item) {
    this.push(item);
    return this;
};

Array.prototype.addArray = function(array) {
    return this.concat(array);
};

Array.prototype.contains = function(item) {
    return this.indexOf(item) >= 0;
};

Array.prototype.lastN = function(amount) {
    if (this.length < amount) {
        return this;
    }
    return this.slice(this.length - amount);
};

Array.prototype.last = function() {
    if (this.length > 0) {
        return this[this.length - 1];
    }

    return undefined;
};